<template>
  <Modal ref="modalRef">
    <template #body>
      <View direction="column" gap="md" padding-block="md" align="center" class="confirmation">
        <Text variant="h2">Delete this listing?</Text>
        <Text variant="body-large" color="secondary" align="center">
          This change is permanent — once made, you won't be able to access or edit this listing again
        </Text>
      </View>
    </template>
    <template #footer>
      <Button variant="ghost" @click="close">Cancel</Button>
      <Button :loading="isLoading" @click="submit">Yes, delete</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal, Text, View, useAlertsStore } from '@tallo/design-system';
import { useNavigation } from '@tallo/investor/navigation';
import { usePropertyStore } from '@tallo/investor/property';

const { openPortfolio } = useNavigation();
const propertyStore = usePropertyStore();
const alertsStore = useAlertsStore();
const modalRef = ref<InstanceType<typeof Modal>>();
const isLoading = ref(false);

async function submit() {
  isLoading.value = true;
  await propertyStore.deleteProperty(propertyStore?.property!.id);
  isLoading.value = false;

  close();
  alertsStore.success(`Listing <b>${propertyStore?.property?.displayName}</b> has been deleted`);
  openPortfolio();
}

function close() {
  modalRef.value?.close();
}

defineExpose({
  modalRef,
});
</script>

<style scoped lang="scss">
.confirmation {
  max-width: 30rem;
}
</style>
